module.exports = __webpack_public_path__ + "img/linkedin.064258dd.svg";